import React, { useEffect, useState } from "react";
import MainFooterComponent from "common/components/MainFooterComponent/MainFooterComponent";
import GameHeader from "common/components/GameHeader/GameHeader";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import PersonalInformationTab from "features/profile/components/personalInformationTab/personalInformationTab";
import SubscriptionDetailsTab from "features/profile/components/SubscriptionDetailsTab/SubscriptionDetailsTab";
import OrdersTab from "features/profile/components/OrdersTab/OrdersTab";
import SettingsTab from "features/profile/components/SettingsTab/SettingsTab";

import "./MyProfile.scss";

import MyProfileHeartCard from "assets/images/MyProfileHeartCardImg.svg";
import { useQuery } from "hooks/useQuery";
import { fetchRequest } from "utils/restApiCleintAxios";
import { localStorageKeys } from "config/localStorageKeys";
import MyProfileMobile from "./MyProfileMobile";
import { showMobile } from "helpers/adaptation";

function MyProfile() {
  const queryData = useQuery();
  const [activeTab, setActiveTab] = useState("home");
  const [dataOrders, setDataOrders] = useState([]);

  useEffect(() => {
    setActiveTab(queryData.get("tab") || "home");
  }, [queryData]);

  useEffect(() => {
    const getData = async () => {
      const userInfoStr = localStorage.getItem(localStorageKeys.userInfo);
      let userInfoParse: any = {};
      if (userInfoStr) {
        userInfoParse = JSON.parse(userInfoStr);
      }
      if (userInfoParse?.ctoken) {
        const res = await fetchRequest("api/user/GetUserOrders", {
          method: "post",
          data: {
            ctoken: userInfoParse?.ctoken
          }
        });
        localStorage.setItem(
          localStorageKeys.makeRequestOrdersDate,
          JSON.stringify({
            data: res?.data?.userDetails?.user?.orders,
            date: new Date(new Date().setMinutes(new Date().getMinutes() + 1))
          })
        );
        setDataOrders(res?.data?.userDetails?.user?.orders);
      }
    };
    const getLocalOrdersStr = localStorage.getItem(localStorageKeys.makeRequestOrdersDate);
    let getLocalOrdersParse: any = {};
    if (getLocalOrdersStr) {
      getLocalOrdersParse = JSON.parse(getLocalOrdersStr);
    }

    if (!getLocalOrdersParse?.date || new Date(getLocalOrdersParse?.date) < new Date()) {
      console.log("getLocalOrdersParse", getLocalOrdersParse);
      getData();
    } else {
      setDataOrders(getLocalOrdersParse?.data);
    }
  }, []);

  return (
    <>
      {showMobile && <MyProfileMobile dataOrders={dataOrders} />}
      {!showMobile && (
        <div className="MyProfile-screen-wrapper">
          <GameHeader />
          <div className="MyProfile-statement-wrapper">
            <div className="MyProfile-heading-otr">
              <h3 className="MyProfile-heading">החשבון שלי</h3>
            </div>
            <div className="MyProfile-Tabs-main">
              <Tabs
                defaultActiveKey={activeTab}
                activeKey={activeTab}
                onSelect={(k: any) => {
                  setActiveTab(k);
                }}
                id="uncontrolled-tab-example"
                className="mb-3">
                <Tab eventKey="home" title="פרטים אישיים">
                  <PersonalInformationTab />
                </Tab>
                <Tab eventKey="profile" title="פרטי המנוי">
                  <SubscriptionDetailsTab />
                </Tab>
                <Tab eventKey="Orders" title="הזמנות">
                  <OrdersTab data={dataOrders} />
                </Tab>
                <Tab eventKey="Settings" title="הגדרות">
                  <SettingsTab />
                </Tab>
              </Tabs>
              <img className="profile-card-img" src={MyProfileHeartCard} alt="img" />
            </div>
          </div>
          <MainFooterComponent />
        </div>
      )}
    </>
  );
}

export default MyProfile;
